module.exports = __webpack_public_path__ + "img/information_inspiring_design.2a4e752.jpg";